import React, { useState, useEffect, useContext } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { UserContext } from "../../Context/UserContext";

function VirtualAccountCard() {
  const { userDetails } = useContext(UserContext);
  const userData = userDetails || {};

  const accNo = userData.virtualAccountNumber || localStorage.getItem("virtualAccountNumber") || "";
  const accName = userData.virtualAccountName || localStorage.getItem("virtualAccountName") || "";

  const copyText = () => {
    if (!accNo) return;
    navigator.clipboard
      .writeText(accNo)
      .then(() => {
        toast.success("Account number copied!", { autoClose: 1000 });
      })
      .catch((err) => { });
  };

  return (
    <div className="p-5 rounded-2xl border border-[#E6E6E7] bg-white h-full flex flex-col justify-between">
      <div>
        <p className="text-[#037441] font-bold text-[14px] mb-4 leading-[32px]">
          Fund wallet with your virtual account number
        </p>

        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <span className="text-[#808285] text-[14px]">Bank name</span>
            <span className="text-[#1A1A1B] font-bold text-[14px]">
              Paystack Titan
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-[#808285] text-[14px]">Account name</span>
            <span className="text-[#1A1A1B] font-bold text-[14px]">
              {accName}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-5 p-3 rounded-xl border border-[#E6E6E7] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-[#1A1A1B] font-bold text-[16px]">
            Account number
          </span>
          <span className="text-[#1A1A1B] text-[18px]">{accNo}</span>
        </div>
        <div
          onClick={copyText}
          className="cursor-pointer p-1 rounded-md hover:bg-gray-100 transition-colors"
        >
          <ContentCopyIcon style={{ color: "#00A85A", fontSize: "24px" }} />
        </div>
      </div>
    </div>
  );
}

export default VirtualAccountCard;
